var GeneralSet = /** @class */ (function () {
    function GeneralSet(items) {
        var _this = this;
        this.map = new Map();
        items === null || items === void 0 ? void 0 : items.forEach(function (item) { return _this.add(item); });
    }
    GeneralSet.prototype.getKey = function (item) {
        if (typeof item === "string" || typeof item === "number") {
            return item;
        }
        else {
            return item.id;
        }
    };
    GeneralSet.prototype.add = function (item) {
        var key = this.getKey(item);
        if (key) {
            this.map.set(key, item);
        }
        else {
            throw new Error('Cannot add elements without id');
        }
    };
    GeneralSet.prototype.values = function () {
        return Array.from(this.map.values());
    };
    GeneralSet.prototype.empty = function () {
        return this.map.size === 0;
    };
    GeneralSet.prototype.size = function () {
        return this.map.size;
    };
    GeneralSet.prototype.has = function (item) {
        var key = this.getKey(item);
        return key ? this.map.has(key) : false;
    };
    GeneralSet.prototype.delete = function (item) {
        var key = this.getKey(item);
        key && this.map.delete(key);
    };
    GeneralSet.prototype.addImmutable = function (item) {
        var newSet = new GeneralSet();
        newSet.map = new Map(this.map);
        newSet.add(item);
        return newSet;
    };
    GeneralSet.prototype.addImmutableMulti = function (items) {
        var newSet = new GeneralSet();
        newSet.map = new Map(this.map);
        items.forEach(function (item) {
            newSet.add(item);
        });
        return newSet;
    };
    GeneralSet.prototype.addMulti = function (items) {
        var _this = this;
        items.forEach(function (item) { return _this.add(item); });
        return this;
    };
    GeneralSet.prototype.deleteImmutable = function (item) {
        var newSet = new GeneralSet();
        newSet.map = new Map(this.map);
        newSet.delete(item);
        return newSet;
    };
    GeneralSet.prototype.deleteImmutableMulti = function (items) {
        var newSet = new GeneralSet();
        newSet.map = new Map(this.map);
        items.forEach(function (item) {
            newSet.delete(item);
        });
        return newSet;
    };
    return GeneralSet;
}());
export { GeneralSet };
